export function buildReturnTo() {
    try {
        const { pathname, search } = window.location;
        return `${pathname}${search}`;
    }
    catch {
        return '/';
    }
}
export function isSafePath(p) {
    return !!p && p.startsWith('/') && !p.startsWith('//');
}
export function makeLoginHref(baseLogin = '/login', target) {
    const rt = isSafePath(target) ? target : buildReturnTo();
    try {
        const url = new URL(baseLogin, 'https://digiwedge.local');
        url.searchParams.set('returnTo', rt);
        const path = url.pathname === '/' && !baseLogin.startsWith('/') ? '' : url.pathname;
        const search = url.searchParams.toString();
        return `${path}${search ? `?${search}` : ''}`;
    }
    catch {
        const sep = baseLogin.includes('?') ? '&' : '?';
        return `${baseLogin}${sep}returnTo=${encodeURIComponent(rt)}`;
    }
}
//# sourceMappingURL=returnTo.js.map